import intlMessagesEN from './i18n/localization/en.json';
import intlMessagesVi from './i18n/localization/vi.json';

export default {
  name: 'Sconfig',
  dir: 'Sconfig',
  pathRoot: 'config',
  routes: [
    {
      url: '',
      component: 'Page/CreateEdit',
      meta: {
        authRoute: true,
      },
      layout: 'FullLayout',
      props: {
        title: 'Trang chủ | Smart Event',
        titleI18n: 'Smtp:title',
        headerStyle: 'fill',
        exact: true,
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: true,
  roles: ['superadmin', 'support', 'mkt'],
};
